"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyleGuide = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Layout_1 = require("../Layout");
var StyleGuide = function (props) {
    var colors = [
        'primary',
        'secondary',
        'light',
        'dark',
        'info',
        'warning',
        'danger',
        'white',
        'black',
    ];
    return (jsx_runtime_1.jsxs(Layout_1.Layout, __assign({ container: "container", row: "row" }, props, { children: [jsx_runtime_1.jsxs(Layout_1.Layout, __assign({ col: "col-md-6 lead" }, { children: [jsx_runtime_1.jsx("h1", __assign({ className: "display-4" }, { children: "font-primary" }), void 0),
                    jsx_runtime_1.jsx("h1", __assign({ className: "display-4 font-secondary" }, { children: "font-secondary" }), void 0),
                    colors.map(function (color) { return (jsx_runtime_1.jsx("div", __assign({ className: "text-" + color }, { children: jsx_runtime_1.jsx("p", __assign({ className: (color === 'white' ? 'bg-black' : '') + " p-2" }, { children: "text-" + color }), void 0) }), "text-" + color)); })] }), void 0),
            jsx_runtime_1.jsx(Layout_1.Layout, __assign({ col: "col-md-6 lead text-center" }, { children: colors.map(function (color) { return (jsx_runtime_1.jsx("div", __assign({ style: { height: '100px', width: '100px' }, className: " d-inline-block border m-2 bg-" + color }, { children: jsx_runtime_1.jsx("p", __assign({ className: color === 'white' ? 'text-black' : 'text-white' }, { children: color }), void 0) }), "bg-" + color)); }) }), void 0)] }), void 0));
};
exports.StyleGuide = StyleGuide;
//# sourceMappingURL=index.js.map